import React, { FC, ReactNode } from "react";

import { Box } from "@mui/material";
import MapMini from "../MapMini/MapMini";

interface ILayoutOnboardingProps {
  children: ReactNode;
  image: string;
  showMap?: boolean;
  mapData?: {
    lat: number;
    lng: number;
    zoom?: number;
  };
  markers?: any[];
  onClick?: any;
  isWebUser?: boolean;
  isBubble?: boolean;
  setIsBubble?: (isBubble: boolean) => void;
  location?: any;
  handleOpenLocationModal?: () => void;
  isSignup?: boolean;
  leftContainerClass?: String;
}

const LayoutOnboarding: FC<ILayoutOnboardingProps> = ({
  children,
  image,
  showMap,
  mapData,
  markers,
  onClick,
  isWebUser,
  isBubble,
  setIsBubble,
  location,
  handleOpenLocationModal,
  isSignup,
  leftContainerClass,
}) => {
  return (
    <Box className="flex flex-col items-center h-full w-full overflow-hidden bg-gray-2">

      {/* Header start */}
      <Box className="flex w-full h-[80px] p-4 shadow-sm bg-white">
        <img src="/assets/icons/logo_black.svg" alt="GoodVets" className="h-8" />
      </Box>
      {/* Header end */}

      <Box className="flex h-full w-full md:justify-center">

        {/* Left container */}
        <Box className={`flex flex-col w-full lg:w-[55%] h-full p-4
          md:px-8 pt-[10%] items-center ${leftContainerClass? leftContainerClass:""}`}>
          <Box className="w-full h-full overflow-y-scroll scroll-hide lg:w-2/3 2xl:w-1/2">
            {children}
            {showMap && mapData && (
              <MapMini
                lat={mapData?.lat}
                lng={mapData?.lng}
                zoom={12.5}
                height="100%"
                width="100%"
                markers={markers}
                mapData={mapData}
                onClick={onClick}

                isBubble={isBubble}
                setIsBubble={setIsBubble}
                location={location}
                handleOpenLocationModal={handleOpenLocationModal}
                isSignup={isSignup}
              />
            )}
          </Box>
        </Box>

        {/* Right container */}
        <Box className="w-[45%] hidden lg:block">
          <img src={image} alt="GoodVets" className="h-full w-full object-cover" />
        </Box>
      </Box>
    </Box>
  );
};

export default LayoutOnboarding;
